import React from "react";
import { Box, Grid, Container } from "@mui/material";
import { Link } from "react-router-dom";
import "../../css/InicioPage/Productos.css"
import fondo from "../../Image/fondo.png"
import idea from "../../Image/idea.png"


export const NosotrosInicio = () => {

  return (
    <section
      style={{
        backgroundImage: `url(${fondo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="lg" sx={{ padding: '100px 0px' }} >
        <Box sx={{ pt: 6 }}>
          <Grid container spacing={1} alignItems="center">
            {/* Columna Izquierda */}
            <Grid size={{ xs: 12, sm: 5 }}>
              <Box display="flex" flexDirection="column" sx={{alignItems:'center'}}>
                <Box
                  component="img"
                  src={idea} // Puedes reemplazar por tu imagen
                   alt="HOD | Maquinas Dispensadoras"
                     title="HOD | Maquinas Dispensadoras"
                  sx={{ width: "30%" }}
                />


              </Box>
            </Grid>

            {/* Columna Derecha con Imagen */}
            <Grid size={{ xs: 12, sm: 7 }} sx={{
              '@media (max-width:600px)': {
       display:'flex',
       alignItems:'center',
       justifyContent:'center',
       flexDirection:'column',
       marginTop:'50px'
    },
            }}>
              <h2 className="descripcionseccionhome">
                Buscamos generar <span>soluciones</span>
              </h2>
              <h2 className="descripcionseccionhome">
                <span>innovadoras y sostenibles</span> que
              </h2>
              <h2 className="descripcionseccionhome">
                impacten positivamente a todos
              </h2>
              <h2 className="descripcionseccionhome">
                los stakeholders del sistema.
              </h2>

              <Link to='/nosotros'>
              <button className="buttondescripcionseccionhome"> Conoce más sobre nosotros</button>
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </section>
  );
};